export default __webpack_public_path__ + "static/media/ergoChair.2a7a0da0.svg";